// extracted by mini-css-extract-plugin
module.exports = {"overlay":"PageHero_overlay__LOS8f","overlayDesktop":"PageHero_overlayDesktop__08O6d"};